module.exports = __webpack_public_path__ + "img/authForteKoFirstTry.d57f9e12.png";